const tableOptionInitialState = () => {
    if (window?.innerWidth >= 768) {
        return {
            activePage: 0,
            rowPerPages: 100,
        }
    } else {
        return {
            activePage: 0,
            rowPerPages: 50,
        }
    }
}
export default tableOptionInitialState
